import { Box, ToggleButton } from "@mui/material";
import { observer } from "mobx-react-lite";
import { MouseEvent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet } from "react-router-dom";
import BriaToggleButtonGroup from "../../../components/common/BriaToggleButtonGroup/BriaToggleButtonGroup";
import RouterConstants from "../../../constants/RouterConstants";
import { useAppStore } from "../../../hooks/useStores";
import PlaygroundImages from "../../Playground/Images/PlaygroundImages";
import { TgAppConfigs } from "../store/new-tg-stores";
import styles from "./TgApp.module.scss";

const TgApp = () => {
	const { t } = useTranslation("tg", { keyPrefix: "app" });
	const { uiStore, tgStore } = useAppStore();
	const hideTabs = true;

	useEffect(() => {
		uiStore.hideSideBar();
		uiStore.showBackButton(
			RouterConstants.APPS.path,
			undefined,
			t("backBtn"),
			undefined,
			undefined,
			undefined,
			t("appName"),
		);

		return () => {
			uiStore.showSideBar();
			uiStore.hideBackButton();
		};
	}, []);

	useEffect(() => {
		if (location.pathname.includes(RouterConstants.APPS.TG.IMAGE.path)) {
			tgStore.selectedAppConfig = "image";
		} else if (location.pathname.includes(RouterConstants.APPS.TG.VIDEO.path)) {
			tgStore.selectedAppConfig = "video";
		}
	}, [location.pathname]);

	const handleConfigChange = (_e: MouseEvent<HTMLElement>, value: TgAppConfigs) => {
		tgStore.selectedAppConfig = value;
	};

	return (
		<Box className={styles.root}>
			<Box className={styles.configsWrapper}>
				{!hideTabs && (
					<BriaToggleButtonGroup
						className={styles.BriaToggleButtonGroup}
						value={tgStore.selectedAppConfig}
						onChange={handleConfigChange}
					>
						<NavLink to={RouterConstants.APPS.TG.IMAGE.fullPath} className={styles.fullSize}>
							<ToggleButton value="image" className={styles.fullSize}>
								{t(`imageBtn`)}
							</ToggleButton>
						</NavLink>
						<NavLink to={RouterConstants.APPS.TG.VIDEO.fullPath} className={styles.fullSize}>
							<ToggleButton value="video" className={styles.fullSize}>
								{t(`videoBtn`)}
							</ToggleButton>
						</NavLink>
					</BriaToggleButtonGroup>
				)}
				<Outlet />
			</Box>
			<PlaygroundImages />
		</Box>
	);
};

export default observer(TgApp);
